import React, { useState } from "react";
import { Box, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/apiClient";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import STLViewer from "@/components/STLViewer";

export default function ServerStlPreview({ fileId, filename }) {
  const [open, setOpen] = useState(false);
  const [blob, setBlob] = useState(null);
  const [loading, setLoading] = useState(false);

  const openPreview = async () => {
    setOpen(true);
    if (blob) return;
    setLoading(true);
    try {
      const res = await api.get(`/files/${fileId}/download?preview=1`, { responseType: "blob" });
      setBlob(res.data);
    } catch (e) {
      toast.error("Impossibile caricare il modello 3D");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        type="button"
        data-testid="server-stl-preview-button"
        onClick={openPreview}
        className="flex items-center gap-1 rounded-md bg-teal-50 px-2 py-1 text-xs font-medium text-teal-700 hover:bg-teal-100 transition-colors"
      >
        <Box className="h-3.5 w-3.5" /> Anteprima 3D
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-3xl" data-testid="server-stl-preview-dialog">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2"><Box className="h-5 w-5 text-teal-600" /> {filename}</DialogTitle>
          </DialogHeader>
          {loading ? (
            <div className="flex flex-col items-center justify-center gap-2 py-20">
              <Loader2 className="h-6 w-6 animate-spin text-teal-600" />
              <span className="text-sm text-slate-500">Caricamento modello 3D...</span>
            </div>
          ) : blob ? (
            <STLViewer file={blob} height={460} />
          ) : null}
        </DialogContent>
      </Dialog>
    </>
  );
}
